
export default {
  name: 'CategoriesSearchBarComponent',
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showSearchBox: false,
    }
  },
}
